<template>
  <div class="grid-container content-page dashbord-soignant">

    <div class="title-page"><h4>Carnet de bord soignant</h4></div>

      <div class="grid-x grid-margin-x">

        <div class="small-12 medium-12 large-12 cell ">

           <ul class="nav-dashbord">
            <li><router-link :to="{ name: 'faq' }"><i class="fas fa-info-circle"></i>Accéder à la FAQ</router-link></li>
            <li><router-link :to="{ name: 'edit_account_caregiver' }"><i class="fas fa-user"></i>Gérer mon profil</router-link></li>
            <li><router-link :to="{ name: 'dashboard-caregiver' }"><i class="fas fa-child"></i>La liste des enfants</router-link></li>
          </ul>

          <div class="box-edit-avatar">

            <div v-if="!currentUser.avatar" class="bubble edit-avatar right txtleft" :class="{on: !currentUser.avatar}">
              <span>
                <div>Pensez à modifier votre avatar.</div>
              </span>
            </div>

            <div class="avatar-profil">
              <div class="avatar-cover">
                <div class="avatar"><img :src="require(`@/assets/images/badges/${currentUser.title}-${currentUser.gender.toLowerCase()}.jpg`)" alt="" title=""/></div>
                <router-link class="edit" :to="{ name: 'edit_account_caregiver' }" title="Editez son avatar"><i class="far fa-edit"></i></router-link>
              </div>
              <div class="infos">
                <h3>{{currentUser.first_name}} {{currentUser.last_name}}</h3>
                <span>Inscrit depuis {{formatDate(currentUser.signup_date)}}</span>
              </div>
            </div>

          </div>
        </div>

        <div  id="ajout-enfant" class="small-12 medium-10 large-8 medium-offset-1 large-offset-2 cell center">

          <h3>Ajouter un enfant à votre carnet de bord</h3>
          <p>Suivez les patients de votre service en faisant partie de leur Team de Soignants, il suffit simplement d'indiquer l'identifiant de l'enfant ci-dessous.
          Une demande de validation sera envoyée aux parents, une fois validé l'enfant sera ajouté à votre carnet de bord.
          </p>

          <div class="formulaire soignant">
            <form ref="form">
              <input type="text" name="identifier" id="identifier" v-model="identifier" placeholder="Identifiant de l'enfant" required />
              <input class="button btnPush" name="submit" type="submit" value="Ajouter cet enfant" @click="send" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapState } from 'vuex'
  import chroma from 'chroma-js'
  import { formatDate } from '@/functions'

  import Bouton from '@/components/Bouton'
  import ItemBadge from '@/components/ItemBadge'
  import ItemTeam from '@/components/ItemTeam'
  import ItemCommunity from '@/components/ItemCommunity'
  import ItemNotif from '@/components/ItemNotif'
  import ItemFiche from '@/components/ItemFiche'
  import TitlePage from '@/components/TitlePage'
  import TitleBox from '@/components/TitleBox'
  import TitleFiche from '@/components/TitleFiche'
  import AvatarProfil from '@/components/AvatarProfil'
  import IfUser from '@/components/IfUser'
  import Avatar from '@/components/Avatar'

  import MedicalTeam from './dashboardComponents/MedicalTeam'
  import BadgesList from './dashboardComponents/BadgesList'
  import ChildTracking from './dashboardComponents/ChildTracking'
  import ParentMenu from './dashboardComponents/ParentMenu'
  import EventCalendar from './dashboardComponents/EventCalendar'
  import EventTimeline from './dashboardComponents/EventTimeline'
  import ItemChild from '@/components/ItemChild'

  export default {
    components: {AvatarProfil, Avatar, Bouton, ItemBadge, ItemTeam, ItemChild, ItemCommunity, ItemNotif, ItemFiche, TitlePage, TitleFiche, TitleBox, MedicalTeam, BadgesList, ChildTracking, ParentMenu, EventCalendar, EventTimeline, IfUser },
    computed: {
      ...mapGetters(['completeName', 'childName']),
      ...mapState(['subaccounts']),
      currentUser() {
        return this.$store.state.me
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        // access to component instance via `vm`
        if(vm.$store.state.me.account_type !== 'caregiver'){
          next({ name: 'dashboard-' + vm.$store.state.me.account_type });
        }
      })
    },
    data() {
      return {
        identifier: ''
      }
    },
    methods: {
      ...mapActions(['sendInvitation', 'addNotice']),
      formatDate,
      async send (e) {
        e.preventDefault();

        try {
          this.sendInvitation({ identifier: this.identifier, role: 'child' })
          this.addNotice({message: `L'invitation a été envoyée avec succès.`})
          this.$router.push({ name: 'dashboard-caregiver' })
        } catch (ex) {
          console.log(ex)
        }
      }
    }
  }
</script>
